<template>
  <div class="service-list-item">
    <img v-if="iconUrl" :src="iconUrl" class="icon" />
    <div :class="metaClassList" class="meta">
      <router-link v-if="route" :to="route" class="name">{{
        name
      }}</router-link>
      <h4 v-else class="name">{{ name }}</h4>
      <div v-if="mainOption" class="option">Option หลัก: {{mainOption}}</div>
      <div v-if="extraOption" class="option">Option เสริม: {{extraOption}}</div>
      <div v-if="servicePrices" class="option">ราคา: {{servicePrices}} บาท</div>
      <p v-if="showDesc" class="desc">{{ desc }}</p>
      <div class="provider">
        <img v-if="provider.logoUrl" :src="provider.logoUrl" class="logo" />
        <p class="name">{{ provider.name }}</p>
      </div>
      <div v-if="qualityUnitText" class="name"> {{ qualityUnitText }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    iconUrl: { type: String, default: "" },
    name: { type: String, default: "" },
    shortDescription: { type: String, default: "" },
    description: { type: String, default: "" },
    provider: { type: Object, default: () => ({}) },
    route: { type: Object, default: undefined },
    servicePrices: { type: [String, Number], default: undefined },
    mainOption: { type: String, default: undefined },
    extraOption: { type: String, default: undefined },
    qualityUnit: { type: String, default: undefined },
    quota: { type: Number, default: undefined },
  },
  computed: {
    desc() {
      if (!this.description) {
        return this.shortDescription;
      }

      if (!this.shortDescription) {
        return this.description;
      }

      return `${this.shortDescription} — ${this.description}`;
    },
    showDesc() {
      return Boolean(this.description) || Boolean(this.shortDescription);
    },
    metaClassList() {
      return { "no-icon": !this.iconUrl };
    },
    qualityUnitText() {
      return this.quota === 0
        ? this.qualityUnit
        : undefined
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
$logoSize: 64px;

.service-list-item {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;

  align-items: flex-start;

  border-bottom: $border;
  padding: ($space / 2) $space;

  > .icon {
    margin-top: 5px;
    display: block;

    border-radius: 8px;
    width: $logoSize;
    height: $logoSize;
    flex: 0 0 $logoSize;
  }

  > .icon + .meta {
    padding-left: $space;
  }

  > .meta {
    display: block;

    flex-grow: 1;
  }
}

.meta {
  min-width: 0;

  > .name {
    display: inline-block;
    font-size: 1rem;

    &:hover {
      color: black;
    }
  }

  > .desc {
    overflow: hidden;
    height: 23px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  > .provider {
    margin-top: 5px;
  }

  > .option {
    font-size: 0.90rem;
    font-weight: normal;
  }
}

.meta p {
  line-height: 1.6;
  font-size: 0.9rem;
  color: #777;
}

.provider {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  > .logo {
    margin-right: 12px;

    border-radius: $border-radius;
    width: 24px;
    height: 24px;
  }
}
</style>
